import Web3 from "web3";
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import CrowdSale from './CrowdSale';
import Admin from './Admin';
import { Web3StatusContext } from "./contexts/Web3StatusContext";

import { DrizzleContext } from "@drizzle/react-plugin";
import { Drizzle } from "@drizzle/store";
import drizzleOptions from "./drizzleOptions";
import Web3Modal from "web3modal";
import { withTranslation, Trans } from 'react-i18next';
import ReactFlagsSelect from 'react-flags-select';
import WalletConnectProvider from "@walletconnect/web3-provider";

//const supportedChains = [5777, "0x539", 4, "0x4", 97, "0x61"];
const supportedChains = [56, "0x38"];

class Main extends React.Component {
  static contextType = Web3StatusContext;

  state = {drizzle : null};
  drizzle = null;
  web3 = null;
  _provider = null;
  mounted = false;

  countryLangMap = {};
  langCountryMap = {};

  constructor(props) {
    super(props)
    
    this.countryLangMap = {'US': 'en', 'TR': 'tr', 'JP': 'ja'};
    this.langCountryMap = {};

    for (var key in this.countryLangMap) {
      if (this.countryLangMap.hasOwnProperty(key)) {
        this.langCountryMap[this.countryLangMap[key]] = key;
      }
    }
  }

  init() {
    drizzleOptions.init(drizzleOptions);

    if(typeof drizzleOptions.web3.customProvider == "string") {
      if(this.context.web3error != null) {
        return;
      }
      this.context.setConnected(false);
      this.context.setWeb3error(drizzleOptions.web3.customProvider);
    }
    else {
      
      if(this.context.web3 != null) {
        return;
      }
      this.context.setConnected(true);
      this.context.setWeb3error(null);
      this.web3 = drizzleOptions.web3.customProvider;
      this.context.setWeb3(this.web3);
      this._provider = this.web3.currentProvider;
    }
  }

  reinitDrizzle() {
    this.drizzle = null;
    this.setState({drizzle: this.drizzle});
    this.initDrizzle();
  }

  initDrizzle() {
    if(this.context.web3error == null &&
      this.context.chainIDerror == null) {
        if(this.drizzle == null) {
          
          this.drizzle = new Drizzle(drizzleOptions);
          this.setState({drizzle: this.drizzle});
        }
      }
      else {
        
        if(this.drizzle != null) {
          this.drizzle = null;
          this.setState({drizzle: null});
          return;
        }
      }
  }

  subscribeEvents() {
    if(typeof this._provider === 'undefined' || this._provider == null)
      return;
    
    this._provider.on("accountsChanged", (accounts) => {
      console.log("accountsChanged");
      //accounts: string[]
      console.log(accounts);
      this.checkAccount(accounts);
    });
    
    // Subscribe to chainId change
    this._provider.on("chainChanged", (chainId) => {
      //chainId: number
      this.checkChainID(chainId);
      console.log(chainId);
    });
    
    // Subscribe to provider connection
    this._provider.on("connect", (info) => {
      //chainId: number
      console.log(info);
      if(!this.checkChainID(info.chainId)) {
        this.context.setConnected(false);
      }
      else {
        this.context.setConnected(true);
      }
    });
    
    // Subscribe to provider disconnection
    this._provider.on("disconnect", (error) => {
      this.context.setConnected(false);
      //error: { code: number; message: string }
      console.log(error);
    });

    this._provider.on('message', (message) => {
      
    });

    this.web3.eth.net.getId().then((chainId) => {
      this.checkChainID(chainId);
    });

    this.web3.eth.getAccounts().then((accounts) => {
      console.log(accounts);
      this.checkAccount(accounts);
    });
  }

  unsubscribeEvents() {
    if(typeof this._provider === 'undefined' || this._provider == null)
      return;

    this._provider.removeAllListeners("accountsChanged");
    
    // Subscribe to chainId change
    this._provider.removeAllListeners("chainChanged");
    
    // Subscribe to provider connection
    this._provider.removeAllListeners("connect");
    
    // Subscribe to provider disconnection
    this._provider.removeAllListeners("disconnect");

    this._provider.removeAllListeners('message');
  }

  componentDidMount() {
    this.context.setConnect(this.connect.bind(this));
    this.context.seti18n(this.props.i18n);

    this.init();
    this.subscribeEvents();

    var lang = this.props.i18n.languages[0];
    var country = this.langCountryMap[lang];
    
    this.setState({value: country});

    this.mounted = true;
  }

  componentDidUpdate() {
    if(!this.mounted)
      return;
    this.init();
  }

  componentWillUnmount() {
    this.unsubscribeEvents();
  }

  checkChainID(chainId) {
    this.context.setActiveChainId(chainId);
    var isSupported = supportedChains.includes(chainId);
    console.log('15 chain id ' + chainId + ' isSupported ' + isSupported);
    if(!isSupported) {
      this.context.setChainIDerror('un supported chain! Switch to Binance Smart Chain on Meta Mask');
      console.log('unsupported chain!');
    }
    else {
      this.context.setChainIDerror(null);
    }
    this.initDrizzle();
    return true;
  }

  checkAccount(accounts) {
    var account = null;
    var accountChanged = false;
    if(this.context.web3 == null)
      return;
    if(accounts.length > 0)
      account = this.context.web3.utils.toChecksumAddress(accounts[0]);
    
    accountChanged = this.context.activeAccount != account;
    this.context.setActiveAccount(account);
    var isSupported = true;
    
    if(!isSupported) {
      this.context.setAccounterror('account not connected!');
      console.log('account not connected');
    }
    else {
      this.context.setAccounterror(null);
    }
    if(accountChanged) {
      this.reinitDrizzle();
    }
    return true;
  }

  async connectWeb3Modal(drizzle, drizzleState) {
    const providerOptions = {
      // Example with injected providers
      /*injected: {
        network: drizzleOptions.network,
        package: null
      },*/
      "window.eth": {
        display: {
          logo: "data:image/gif;base64,INSERT_BASE64_STRING",
          name: "Browser Provider",
          description: "Connect to your Browser provider"
        },
        connector: async (ProviderPackage, options) => {
          
            return this.web3;
        }
      },
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          rpc: {
            56: "https://bsc-dataseed.binance.org",
          },
          network: 'binance',
          chainId: 56,
          infuraId: ""
        }
      }    
    };

    const web3Modal = new Web3Modal({
      //network: "binance", // optional
      cacheProvider: true, // optional
      providerOptions // required
    });

    web3Modal.connect().then(function(_provider) {
      const web3 = new Web3(_provider);
      drizzleOptions.web3.customProvider = web3;
      this.init();
      this.subscribeEvents();
    }.bind(this));
  }

  async connectWalletConnect(drizzle, drizzleState) {
    const provider = await new WalletConnectProvider({
      rpc: {
          56: "https://bsc-dataseed1.binance.org",
      },
      chainId: 56,
      network: "binance"
    });
    /*await provider.disconnect();
    await provider.wc.createSession({
      chainId: 56
    });*/

    await provider.enable();
    const web3 = await new Web3(provider);
    drizzleOptions.web3.customProvider = web3;
    this.init();
    this.subscribeEvents();
  }

  async connect(drizzle, drizzleState) {
    console.log('connect');
    await this.connectWalletConnect();
  }

  onLanguageHandle = (event) => {
    var country = event;
    var lang = this.countryLangMap[country];
    this.setState({value: country})
    this.props.i18n.changeLanguage(lang)
  }
 
  renderRadioButtons = () => {
    return (
      <div>
        
        <ReactFlagsSelect
          selected={this.state.value}
          onSelect={(e) => this.onLanguageHandle(e)}
          countries={["US", "TR"/*, "JP"*/]}
          customLabels={{
            "US": { primary: "English" },
          }}
          placeholder="Select Language"
          fullWidth={false}
        />
      </div>
    )
  }

  render() {
    if(this.context.web3error != null) {
      var error = this.context.web3error;
      return (
        <div style={{ textAlign: 'center'}}>
          <div>
            {error}
          </div>
          <div>
            <button onClick={this.connect.bind(this)}>
              Connect Wallet
            </button>
          </div>
        </div>
      );
    }
    
    if(this.context.chainIDerror != null) {
      var error = this.context.chainIDerror;
      return error;
    }
    
    if(this.state.drizzle == null) {
      return (<div><Trans>loading</Trans></div>);
    }

    return (
      <DrizzleContext.Provider drizzle={this.state.drizzle}>
        <DrizzleContext.Consumer>
          
          {drizzleContext => {
            const { drizzle, drizzleState, initialized } = drizzleContext;
            
            if (!initialized) {
              return <Trans>loading</Trans>;
            }

            if(this.context.accounterror != null) {
              var error = this.context.accounterror;
              return error;
            }

            return (
              <div className="App">
                { this.renderRadioButtons() }
                <Switch> {/* The Switch decides which component to show based on the current URL.*/}
                  <Route exact path="/"
                    render={() => (
                        <CrowdSale drizzle={drizzle}
                        drizzleState={drizzleState} />
                    )}></Route>
                  <Route path='/admin' render={() => (
                        <Admin drizzle={drizzle}
                        drizzleState={drizzleState} />
                    )}></Route>
                </Switch>
              </div>
            )
          }}
          
        </DrizzleContext.Consumer>
      </DrizzleContext.Provider>
    );
  }
}

export default Main;